import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/home";
import Layout from "@/views/layout";
Vue.use(Router);

//获取原型对象上的replace函数
const originalReplace = Router.prototype.replace;
//修改原型对象中的replace方法
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new Router({
  routes: [
    {
      path: "/",
      component: Layout,
      redirect: "/home",
      children: [
        {
          path: "home",
          name: "home",
          component: () =>
            import(/* webpackChunkName: "views" */ "@/views/home")
        },
        {
          path: "solution",
          name: "solution",
          component: () =>
            import(/* webpackChunkName: "views" */ "@/views/solution")
        },
        {
          path: "customization",
          name: "customization",
          component: () =>
            import(/* webpackChunkName: "views" */ "@/views/customization")
        },
        {
          path: "aboutus",
          name: "aboutus",
          component: () =>
            import(/* webpackChunkName: "views" */ "@/views/aboutus")
        },
        {
          path: "contact",
          name: "contact",
          component: () =>
            import(/* webpackChunkName: "views" */ "@/views/contact")
        }
      ]
    }
  ],
  scrollBehavior(to, from,savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
});

// router.beforeEach((to, from, next) => {
//   // 如果用户访问的登录页，直接放行
//   if (
//     to.path === "/login" ||
//     to.path === "/home" ||
//     to.path === "/productInfo" ||
//     to.path === "/test" ||
//     to.path === "/user/order" ||
//     to.path === "/productList" ||
//     to.path === "/sales" ||
//     to.path === "/privacy" ||
//     to.path === "/refund" ||
//     to.path === "/faq"
//   )
//     return next();
//   // 没有token，强制跳转到登录页
//   let authorization = Vue.cookie.get("Authorization");
//   if (!authorization || !/\S/.test(authorization)) {
//     Message.error("Please login first");
//     next({
//       name: "login"
//     });
//   }
//   next();
// });

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js